import { render } from "./IconChevronDoubleRight.vue?vue&type=template&id=227805e3"
import script from "./IconChevronDoubleRight.vue?vue&type=script&lang=js"
export * from "./IconChevronDoubleRight.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__